import { Params } from '@angular/router'
import { LiveEvent } from '@flocasts/flosports30-types/dist/entity'

export const redirectIsAccountSettings = (redirect: string) => redirect.match(/^\/account.*$/)
export const redirectIsActivate = (redirect: string) => redirect.match(/^\/activate.*$/)
export const nextIsArena = (next: string) => next.match(/arena.*$/)

/**
 * @param isFreeUser - a user that does not have a subscription
 * @param queryParam - the query parameters from the URL
 * @param liveEvent - the live event the user is trying to access
 */
export const shouldRouteToPlansOrPay = (isFreeUser: boolean, queryParam: Params = {}, liveEvent?: LiveEvent) => {
  if (
    queryParam.redirect &&
    (redirectIsAccountSettings(queryParam.redirect) || redirectIsActivate(queryParam.redirect))
  ) {
    return false
  }

  if (queryParam.next && nextIsArena(queryParam.next)) {
    return false
  }

  // if in free paywall
  if (queryParam.fp) {
    return false
  }
  // if in gift subscription
  if (queryParam.giftSub) {
    return false
  }
  // if in free registration
  if (queryParam.register) {
    return false
  }

  /**
   * If free user is accessing a free live event, skip Plan and Pay routes
   * Otherwise if a free user, redirect to Plan and Pay routes
   */
  if (isFreeUser) {
    if (!!queryParam.redirect) {
      const isLiveEventFree = liveEvent && !liveEvent.premium
      return !isLiveEventFree
    } else {
      return true
    }
  }

  return false
}
